import { BrowserRouter, Routes, Route } from "react-router-dom";
import { DynamicFavicon } from "@/components/DynamicFavicon";
import { PageTracker } from "@/components/PageTracker";

import HomePage from "@/pages/Home";
import WallPage from "@/pages/Wall";
import OfferStreamPage from "@/pages/OfferStream";
import OfferPwaPage from "@/pages/OfferPwa";
import ContactPage from "@/pages/Contact";
import NowPlayingPage from "@/pages/NowPlaying";

import AdminLoginPage from "@/pages/admin/Login";
import AdminDashboardPage from "@/pages/admin/Dashboard";
import AdminHistoryPage from "@/pages/admin/History";
import AdminRadiosPage from "@/pages/admin/Radios";
import AdminAnalyticsPage from "@/pages/admin/Analytics";
import { ProtectedRoute } from "@/components/admin/ProtectedRoute";

import "@/App.css";
import "@/mediaweb.css";
import "@/admin.css";
import "@/nowplaying.css";

export default function App() {
  return (
    <BrowserRouter>
      <DynamicFavicon />
      <PageTracker />
      <Routes>
        {/* Public */}
        <Route path="/" element={<HomePage />} />
        <Route path="/wall" element={<WallPage />} />
        <Route path="/offre-stream" element={<OfferStreamPage />} />
        <Route path="/offre-pwa" element={<OfferPwaPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/now-playing" element={<NowPlayingPage />} />

        {/* Admin */}
        <Route path="/admin" element={<AdminLoginPage />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route
          path="/admin/artwork"
          element={
            <ProtectedRoute>
              <AdminDashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/history"
          element={
            <ProtectedRoute>
              <AdminHistoryPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/radios"
          element={
            <ProtectedRoute>
              <AdminRadiosPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/analytics"
          element={
            <ProtectedRoute>
              <AdminAnalyticsPage />
            </ProtectedRoute>
          }
        />

        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}
